/*
 * @Author: Json Chen
 * @Date: 2021-07-14 17:12:44
 * @LastEditTime: 2021-07-14 17:19:46
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/TimePickerRangePicker.tsx
 */

import { TimePicker } from 'antd';
import moment from 'moment';
import React from 'react';

const TimePickerRangePicker = ({ value, onChange, ...props }: any) => {
  const _onChange = (newVal) => {
    if (newVal) {
      onChange(newVal.map((i) => i.format('HH:mm')));
    } else {
      onChange([]);
    }
  };
  return (
    <TimePicker.RangePicker
      value={value.map((i) => {
        if (!i) {
          return null;
        }

        const [hour, minute] = i.split(':');

        return moment().set({
          hour,
          minute,
        });
      })}
      onChange={_onChange}
      {...props}
    />
  );
};

export default TimePickerRangePicker;
